import { render, staticRenderFns } from "./FloorMap.vue?vue&type=template&id=812ca4f2&scoped=true&"
import script from "./FloorMap.vue?vue&type=script&lang=js&"
export * from "./FloorMap.vue?vue&type=script&lang=js&"
import style0 from "./FloorMap.vue?vue&type=style&index=0&id=812ca4f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812ca4f2",
  null
  
)

export default component.exports